import { createNextTableContext } from '@core/table';

export const BranchPartnersTableContext = createNextTableContext();
